// extracted by mini-css-extract-plugin
module.exports = {"root":"vuBbZt"};